// `Symbol.match` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.match
require('../internals/define-well-known-symbol')('match');